import { render, staticRenderFns } from "./JobBoard.vue?vue&type=template&id=16cf777e&scoped=true"
import script from "./JobBoard.vue?vue&type=script&lang=js"
export * from "./JobBoard.vue?vue&type=script&lang=js"
import style0 from "./JobBoard.vue?vue&type=style&index=0&id=16cf777e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16cf777e",
  null
  
)

export default component.exports